import { render, staticRenderFns } from "./FormSubmitSuccessMessage.vue?vue&type=template&id=065e5eda&"
import script from "./FormSubmitSuccessMessage.vue?vue&type=script&lang=js&"
export * from "./FormSubmitSuccessMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065e5eda')) {
      api.createRecord('065e5eda', component.options)
    } else {
      api.reload('065e5eda', component.options)
    }
    module.hot.accept("./FormSubmitSuccessMessage.vue?vue&type=template&id=065e5eda&", function () {
      api.rerender('065e5eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicesservicerequest/FormSubmitSuccessMessage.vue"
export default component.exports